



















































// codemirror css
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/hint/show-hint.css';
import './scss/editormd.scss';

import CodeMirror from 'codemirror';
import Marked from 'marked';
import FileUpload from 'vue-upload-component';

// codemirror addon
import 'codemirror/addon/hint/show-hint';
import './extension/at-mention-hint';
// import 'codemirror/addon/hint/javascript-hint'
// import 'codemirror/addon/hint/anyword-hint'

// fold
import 'codemirror/addon/fold/foldcode';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/comment-fold';
// run mode
import 'codemirror/addon/runmode/runmode';
import 'codemirror/addon/selection/active-line';

import 'codemirror/mode/gfm/gfm';
import 'codemirror/mode/python/python';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/edit/continuelist';

import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';

import EditorMD from './libs/editormd';
import * as utils from './libs/utils';
import * as ResouceManager from './libs/ResourceManager';
import { addResizeListener } from './libs/resize-event';

import { ModalsContainer, default as ModalService } from './modal';

import Toolbar from './Toolbar.vue';
import Help from './Help.vue';
import AddImage from './AddImage.vue';

@Component({
    components: { ModalsContainer, Toolbar, FileUpload },
})
export default class MarkdownEditor extends Vue {
    private files = [];
    // private markdownToC = [];
    // private id = utils.guid();
    private dValue = null; // v-mode
    private dPreviewHtml = '';
    private loading: any = null;
    private cm: any;
    private ready: boolean;
    private resizeHandler: any;
    private _dynamicContainer: any;

    // state
    private dFullscreen = false;
    private dPreview = false;
    private dWatching = null;
    private dResize = false;
    // 缓存用toolbar mode
    private dToolbarMode = '';
    // private d_sync_scrolling = true;
    private dViewWidth = window.innerWidth;
    private dViewHeight = window.innerHeight;

    /* eslint-disable @typescript-eslint/no-empty-function */
    @Prop({ type: [Object], default: () => {} })
    private options;

    @Prop({ type: [String] })
    private value: string;

    /**
     * 实时预览模式
     *
     * 默认值：true
     * */
    @Prop({ type: [Boolean], default: false })
    private watch: boolean;

    // 显示风格

    /**
     * 编辑器主题
     *
     * 编辑器整体皮肤主题，默认支持【default】、【dark】
     * 默认值：default
     * */
    @Prop({
        type: [String],
        default: 'default',
        validator: theme => {
            return EditorMD.themes.indexOf(theme) > -1;
        },
    })
    private theme: string;

    /**
     * 编辑器CodeMirror主题
     *
     * 编辑器底层CodeMirror主题，支持CodeMirror的主题
     * 默认值：default
     * */
    @Prop({
        type: [String],
        default: 'default',
        validator: theme => {
            return EditorMD.editorThemes.indexOf(theme) > -1;
        },
    })
    private editorTheme: string;

    /**
     * 是否显示编辑器行号
     *
     * 默认值：true
     * */
    @Prop({ type: [Boolean], default: true })
    private editorLineNumber: boolean;

    /**
     * 编辑器预览视图主题
     *
     * 编辑器预览视图区主题，支持【default】、【dark】
     * 默认值：default
     * */
    @Prop({
        type: [String],
        default: 'default',
        validator: theme => {
            return EditorMD.previewThemes.indexOf(theme) > -1;
        },
    })
    private previewTheme: string;

    /**
     * 阅读或预览模式下是否高亮代码片段
     *
     * 默认值：true
     * */
    @Prop({ type: [Boolean], default: true })
    private previewCodeHighlight: boolean;

    /**
     * 指定编辑器高度
     *
     * 支持格式：640、"640px"、"auto"
     * 默认值：640
     * */
    @Prop({ type: [String, Number], default: '320' })
    private height: string | number;

    /**
     * 指定编辑器多语言
     *
     * 支持格式：zh-cn、us-en
     * 默认值：zh-cn
     * */
    @Prop({ type: [String], default: 'zh-ch' })
    private lang: string;

    /**
     * 编辑器模式
     *
     * 编辑器模式目前支持【阅读】【编辑】两种模式
     * 默认值：editor
     * */
    @Prop({
        type: [String],
        default: 'editor',
        validator: mode => {
            return EditorMD.modes.indexOf(mode) > -1;
        },
    })
    private mode: string;

    /**
     * 编辑器模式
     *
     * 编辑器工具栏模式【none】【mini】【simple】【full】模式模式
     * 默认值：reader模式下为none，即不显示工具栏，editor模式下模式为full
     * */
    @Prop({
        type: [String],
        default: () => {
            return this.mode === 'reader' ? 'none' : 'full';
        },
        validator: mode => {
            return EditorMD.toolbarModes[mode] !== undefined;
        },
    })
    private toolbarMode: string;

    // 功能开关

    /**
     * 是否开启Html
     *
     * 默认值：false
     * */
    @Prop({ type: [Boolean], default: false })
    private htmlDecode: boolean;

    /**
     * TOC内容目录
     *
     * 是否开启[TOC]支持
     * 默认值：false
     * */
    @Prop({ type: [Boolean], default: false })
    private toc: boolean;

    /**
     * @链接高亮功能
     *
     * 是否开启@链接功能，支持链接内容高亮和外部链接跳转
     * 默认值：false
     * */
    @Prop({ type: [Boolean], default: true })
    private atLink: boolean;

    /**
     *  @提及功能，关联系统用户
     *
     *  默认值：false
     * */
    @Prop({ type: [Boolean], default: true })
    private atMention: boolean;

    @Prop({ type: [String], default: 'https://www.datafountain.cn/users/' })
    private mentionUrl: string;

    /**
     * 提及方法，供外部自定义获取提及的内容
     * */
    @Prop({ type: [Function], default: () => {} })
    private mention: Function;

    @Prop({ type: [Boolean], default: false })
    private syncScrolling: boolean;

    /**
     *  邮箱地址高亮
     *
     *  默认值: false
     * */
    @Prop({ type: [Boolean], default: true })
    private emailLink: boolean;

    /**
     * 分页符
     *
     *  是否支持解析分页符  [========]
     *  默认值: true
     * */
    @Prop({ type: [Boolean], default: true })
    private pageBreak: boolean;

    /**
     * Github Flavored Markdown风格的任务列表
     *
     * 是否开启GFM任务列表功能
     * 默认值: true
     * */
    @Prop({ type: [Boolean], default: true })
    private taskList: boolean;

    /**
     * emoji表情符
     *
     * 是否开启emoji表情符支持，目前支持Github emoji， Twitter Emoji、
     * fontAwesome icon emoji :fa-xxx: > Using fontAwesome icon web fonts
     * 默认值: false
     * */
    @Prop({ type: [Boolean], default: true })
    private emoji: boolean;

    /**
     * 数学公式，TeX(LaTeX), based on KaTeX
     *
     * 是否开启数学公式支持
     * 默认值: false
     * */
    @Prop({ type: [Boolean], default: true })
    private tex: boolean;

    /**
     * FlowChart流程图
     *
     * 是否开启flowChart流程图支持， 基于flowChart.js，only support IE9+
     * 默认值: false
     * */
    // @Prop({ type: [Boolean], default: false})
    // private flowChart: boolean;

    /**
     * Sequence to sequence 模型图
     *
     * 是否开启Sequence to sequence模型图解析支持，基于sequenceDiagram.js，only support IE9+
     * 默认值: false
     * */
    // @Prop({ type: [Boolean], default: false})
    // private sequenceDiagram: boolean;

    get settings() {
        return utils.extend(true, {}, EditorMD.defaults, this.options || {});
    }

    get classes() {
        const classes = [];
        // 主题
        if (this.theme) {
            classes.push('markdown-panel__theme-' + this.theme);
        }
        // 全屏
        if (this.dFullscreen) {
            classes.push('markdown-panel__fullscreen');
        }

        return classes;
    }

    get styles() {
        const styles: {[key: string]: any} = {};
        // 全屏
        if (this.dFullscreen) {
            styles.width = Math.max(this.dViewWidth, window.innerWidth) + 'px';
            styles.height = Math.max(this.dViewHeight, window.innerHeight) + 'px';
            styles.zIndex = 999999;
        }

        return styles;
    }

    get showPreviewToolbar() {
        return this.mode !== 'reader';
    }

    get toolbarItems() {
        return EditorMD.toolbarModes[this.dToolbarMode] || [];
    }

    created() {
        this.dValue = this.$props.value || null; // v-mode
        this.dWatching = this.$props.watch || null;
        this.dToolbarMode = this.$props.toolbarMode || '';
        this.$nextTick(() => {
            this._dynamicContainer = this.$refs.container;
        });
    }

    async mounted() {
        await this._setupResources();
        this.ready = true;

        if (this.mode === 'reader') {
            if (this.value) {
                this.convert(this.value);
            }
            return;
        }
        await this._setupCodeMirror();
        // handle resize event
        addResizeListener(this.$el, utils.throttle(this._handleResize, 300));
        this.syncScrolling && this.bindScrollEvent();
    }

    private updatetValue(value) {
        const file = this.files[0] || {}; // 首次上传图片时files为空数组
        if ((this.$refs.upload as any).uploaded && /100/.test(file.progress)) {
            // 参考 DFForums/web/components/markdown-editor/Toolbar.vue 文件中 image() 函数的逻辑，点击markdown的标题栏中的上传图片的按钮可以看到这个逻辑
            const url = file.response.url;
            const desc = file.name;
            this.cm.replaceSelection(`<img alt="${desc}" src="${url}" style="width=100px height=100px"/>`);
            // this.cm.replaceSelection(`![${desc}](${url})`);
            this.hidenImage();
            this.loading.close();
        }
    }

    /**
     * Has changed
     * @param  Object|undefined   newFile   只读
     * @param  Object|undefined   oldFile   只读
     * @return undefined
     */
    private inputFile(newFile, oldFile) {
        if (newFile && !newFile.active) {
            (this.$refs.upload as any).active = true;
        }
        if (newFile && oldFile && !newFile.active && oldFile.active) {
            // 获得相应数据
            // console.log('response', newFile.response)
            if (newFile.xhr) {
                //  获得响应状态码
                // console.log('status', newFile.xhr.status)
            }

            // Automatically activate upload
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                (this.$refs.upload as any).active = true;
            }
        }
    }

    /**
     * Pretreatment
     * @param  Object|undefined   newFile   读写
     * @param  Object|undefined   oldFile   只读
     * @param  Function           prevent   阻止回调
     * @return undefined
     */
    private inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            // 过滤不是图片后缀的文件
            if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                return prevent();
            }
        }

        // 创建 blob 字段 用于图片预览
        newFile.blob = '';
        const URL = (window as any).URL || (window as any).webkitURL;
        if (URL && URL.createObjectURL) {
            // loading
            this.loading = this.$loading({
                text: '上传图片',
                spinner: 'el-icon-loading',
            });
            newFile.blob = URL.createObjectURL(newFile.file);
        }
    }

    private async _setupResources() {
        // await ResouceManager.loadJQueryOrZepto();
        const resouces = [ResouceManager.loadJQueryOrZepto()];
        // prettify
        if (this.previewCodeHighlight) {
            resouces.push(ResouceManager.loadPrettify());
        }
        // tex
        if (this.tex) {
            resouces.push(ResouceManager.loadKaTex());
        }
        // flow chart or sequence diagram
        // if (this.flowChart || this.sequenceDiagram) {
        //     // TODO:
        // }

        await Promise.all(resouces);
    }

    private async _setupCodeMirror() {
        // 设置CodeMirror编辑器
        const settings = { ...EditorMD.defaults };
        // 加载除默认主题之外的其他主题
        if (this.editorTheme !== 'default') {
            ResouceManager.loadCodeMirrorTheme(this.editorTheme);
        }

        this.cm = CodeMirror.fromTextArea((this.$refs as any).editor, {
            mode: 'gfm',
            theme: this.editorTheme,
            tabSize: 4,
            dragDrop: false,
            autofocus: true,
            autoCloseTags: true,
            readOnly: false,
            indentUnit: 4,
            lineWrapping: true,
            extraKeys: {
                // 'Ctrl-Q': function (cm) {
                //     cm.foldCode(cm.getCursor())
                // },
                Enter: 'newlineAndIndentContinueMarkdownList',
            },
            lineNumbers: this.editorLineNumber,
            foldGutter: this.editorLineNumber,
            gutters: this.editorLineNumber ? ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'] : [],
            matchBrackets: true,
            indentWithTabs: true,
            styleActiveLine: true,
            styleSelectedText: true,
            autoCloseBrackets: true,
            showTrailingSpace: true,
            highlightSelectionMatches: !settings.matchWordHighlight
                ? false
                : { showToken: `${settings.matchWordHighlight}` === 'onselected' ? false : /\w/ },

            hintOptions: {
                mention: this._handleMention,
            },
        } as any);
        // 绑定事件
        this.cm.on('change', utils.throttle(this._handleChange, 500, { leading: true }));
        this.cm.on('cursorActivity', this._handleCursorActivity);
        // this._bindKeyMaps();
        // 填充初始值
        if (this.value) {
            this.ready && this.cm.setValue(this.value);
        }
    }

    // resize handler
    private async _handleResize(e) {
        if (this.mode === 'reader') {
            return;
        }

        if (this.dToolbarMode && this.dToolbarMode !== 'none') {
            const $toolbar = this.$el.querySelector('.markdown-panel__toolbar');
            // console.log('toolbar height::%d', $toolbar.clientHeight)
            (this.$refs.ws as any).style.paddingTop = $toolbar.clientHeight + 'px';
        }
    }

    // 处理窗口大小变更
    private async _handleViewResize() {
        this.dViewWidth = window.innerWidth;
        this.dViewHeight = window.innerHeight;
    }

    private _autocompleteAfter(cm, pred) {
        const cur = cm.getCursor();
        if (!pred || pred())
            setTimeout(function() {
                if (!cm.state.completionActive) cm.showHint({ completeSingle: false });
            }, 100);
        return CodeMirror.Pass;
    }

    // codemirror "change" handler
    private async _handleChange(cm) {
        // 如果当前非实时预览模式
        this.dValue = cm.getValue();
        this.$emit('input', this.dValue);
        if (!this.dWatching) {
            return;
        }
        // console.log('time: %d', new Date().getTime());
        this.save();
    }

    private async _handleCursorActivity(cm) {
        const cur = cm.getCursor();
        let range = cm
            .getRange({ line: cur.line, ch: 0 }, cur, ' ')
            .split(' ')
            .slice(-1)[0];
        if (range[0] === '@') {
            range = range.slice(1);
            if (!cm.state.completionActive) {
                cm.showHint({ completeSingle: false });
            } else {
                const spos = cm.getCursor('start');
                cm.state.completionActive.startPos = spos;
                cm.state.completionActive.startLen = cm.getLine(spos.line).length - cm.getSelection().length;
                cm.state.completionActive.update();
            }
        }
    }

    private async _handleToolbar(item) {
        // console.log(item);
    }

    private async _bindKeyMaps() {}

    private _handleMention(search) {
        return Promise.resolve(this.atMention && this.mention(search)).catch(_ => {
            return null;
        });
    }

    private async save() {
        this.convert(this.dValue);
    }

    private convert(content) {
        const settings = this.settings;
        if (settings.mode !== 'gfm' && settings.mode !== 'markdown') {
            // this.$refs.editor.value = cmValue;
            return;
        }

        const rendererOptions = {
            toc: this.toc,
            // tocm: settings.tocm,
            tocStartLevel: settings.tocStartLevel,
            pageBreak: this.pageBreak,
            taskList: this.taskList,
            emoji: this.emoji,
            tex: this.tex,
            atLink: false, // for @link
            emailLink: this.emailLink, // for mail address auto link
            mentionLink: this.atMention,
            mentionLinkBase: this.mentionUrl,
            // flowChart: this.flowChart,
            // sequenceDiagram: this.sequenceDiagram,
            previewCodeHighlight: this.previewCodeHighlight,
        };

        const toc = [];
        const markedOptions = {
            renderer: EditorMD.createMarkedRender(toc, rendererOptions),
            gfm: true,
            tables: true,
            breaks: true,
            pedantic: false,
            sanitize: !!this.htmlDecode, // 关闭忽略HTML标签，即开启识别HTML标签，默认为false
            smartLists: true,
            smartypants: true,
            highlight: function(code, lang, callback) {
                // let out = Prism.highlight(code, Prism.languages[lang || 'markup']);
                // return out;
            },
        };

        // Marked.setOptions(markedOptions);
        let newMarkdownDoc = Marked(content, markedOptions);
        newMarkdownDoc = EditorMD.filterHTMLTags(newMarkdownDoc, this.htmlDecode);
        // 没有变化
        // 用户通过回车键入多空行时，markdown解析出来的html不变
        if (newMarkdownDoc === this.dPreviewHtml) {
            return;
        }

        // 阅读模式
        // 实时预览
        // 预览
        if (this.mode === 'reader' || this.dWatching || this.dPreview) {
            this.dPreviewHtml = newMarkdownDoc;

            // hightlight preview code
            if (this.previewCodeHighlight) {
                this.highlightPreviewCode();
            }

            // toc
            if (this.toc) {
                const tocHtml = this.getTocHtml(toc);
                this.$nextTick(() => {
                    const toc = (this.$refs.preview as any).querySelectorAll('.markdown-toc-container');
                    if (toc.length) {
                        for (let i = 0, len = toc.length; i < len; i++) {
                            toc[i].innerHTML = tocHtml;
                        }
                    }
                });
            }

            // tex
            if (this.tex) {
                this.katexRender();
            }
        }
    }

    private convertToHtml(content) {
        const settings = this.settings;

        const rendererOptions = {
            toc: this.toc,
            // tocm: settings.tocm,
            tocStartLevel: settings.tocStartLevel,
            pageBreak: this.pageBreak,
            taskList: this.taskList,
            emoji: this.emoji,
            tex: this.tex,
            atLink: false, // for @link
            emailLink: this.emailLink, // for mail address auto link
            mentionLink: this.atMention,
            mentionLinkBase: this.mentionUrl,
            // flowChart: this.flowChart,
            // sequenceDiagram: this.sequenceDiagram,
            previewCodeHighlight: this.previewCodeHighlight,
        };

        const toc = [];
        const markedOptions = {
            renderer: EditorMD.createMarkedRender(toc, rendererOptions),
            gfm: true,
            tables: true,
            breaks: true,
            pedantic: false,
            sanitize: !!this.htmlDecode, // 关闭忽略HTML标签，即开启识别HTML标签，默认为false
            smartLists: true,
            smartypants: true,
            highlight: function(code, lang, callback) {
                // let out = Prism.highlight(code, Prism.languages[lang || 'markup']);
                // return out;
            },
        };

        // Marked.setOptions(markedOptions);
        let newMarkdownDoc = Marked(content, markedOptions);
        newMarkdownDoc = EditorMD.filterHTMLTags(newMarkdownDoc, this.htmlDecode);

        return newMarkdownDoc;
    }

    private getTocHtml(toc: any[], tocDropdown?: any, startLevel?: any) {
        let html = '';
        let lastLevel = 0;
        const classPrefix = EditorMD.classPrefix;

        startLevel = startLevel || 1;

        for (let i = 0, len = toc.length; i < len; i++) {
            const text = toc[i].text;
            const level = toc[i].level;

            if (level < startLevel) {
                continue;
            }

            if (level > lastLevel) {
                html += '';
            } else if (level < lastLevel) {
                html += new Array(lastLevel - level + 2).join('</ul></li>');
            } else {
                html += '</ul></li>';
            }

            html +=
                '<li><a class="toc-level-' +
                level +
                '" href="#' +
                text +
                '" level="' +
                level +
                '">' +
                text +
                '</a><ul>';
            lastLevel = level;

            if (i === len - 1 && lastLevel > startLevel) {
                html += new Array(lastLevel - startLevel + 2).join('</ul></li>');
            }
        }

        return `<div class="markdown-toc ${classPrefix}markdown-toc">
                                    <ul class="markdown-toc-list">${html}</ul>
                             </div>`.replace(/\r?\n?<ul><\/ul>/g, '');
    }

    /**
     * Katex render
     */
    private katexRender() {
        // if (this._timer === null) {
        //     return this;
        // }

        this.$nextTick(() => {
            const windowRef: any = window;
            if (!windowRef.katex) return;

            const prenodes = (this.$refs.preview as any).querySelectorAll('.markdown-panel__tex');
            for (let i = 0; i < prenodes.length; i++) {
                const node = prenodes[i];
                windowRef.katex.render(node.textContent, node);
                node.querySelector('.katex').style.fontSize = '1.6em';
            }
        });
    }

    /**
     * 高亮预览HTML的pre代码部分
     * highlight of preview codes
     *
     * @returns {editormd}             返回editormd的实例对象
     */
    private highlightPreviewCode() {
        const windowRef: any = window;
        this.$nextTick( () => {
            if (windowRef.PR && windowRef.PR.prettyPrint) {
                const prenodes = (this.$refs.preview as any).querySelectorAll('pre:not(.prettyprint)');
                utils.addClass(prenodes, 'prettyprint', 'linenums');
                windowRef.PR.prettyPrint();
            }
        });
    }

    /**
     * toggle toolbar
     *
     * */
    private showToolbar(show) {
        // 阅读模式下不显示toolbar
        if (this.mode === 'reader') {
            return;
        }

        // 显示toolbar
        if (show && this.toolbarMode) {
            this.dToolbarMode = this.toolbarMode;
            return;
        }

        // 隐藏toolbar
        if (!show) {
            this.toolbarMode = this.dToolbarMode;
            this.dToolbarMode = 'none';
        }
    }

    /**
     * 绑定同步滚动
     *
     * @returns {editormd} return this
     */
    private bindScrollEvent() {
        const preview: any = this.$refs.preview;
        const settings = this.settings;
        const cm = this.cm;
        const cmEle = this.cm.getWrapperElement();
        const cmScrollEle = cmEle.querySelector('.CodeMirror-scroll');

        if (!settings.syncScrolling) {
            return this;
        }

        const _cmirrorScrollHandler = function(event) {
            const { top, height, clientHeight } = cm.getScrollInfo();
            const percent = top / height;

            const tocHeight = 0;

            // preview.querySelectorAll(".markdown-toc-list").each(function () {
            //     tocHeight += $(this).height();
            // });

            const tocMenuHeight = 0; //preview.find(".editormd-toc-menu").height();
            // tocMenuHeight = (!tocMenuHeight) ? 0 : tocMenuHeight;

            if (top === 0) {
                // preview.scrollTop(0);
                preview.scrollTop = 0;
            } else if (top + clientHeight >= height - 16) {
                preview.scrollTop = preview.scrollHeight;
            } else {
                preview.scrollTop = (preview.scrollHeight + tocHeight + tocMenuHeight) * percent;
            }

            // this.$emit('scroll')
        };
        const _previewScrollHander = function(event) {
            const height = preview.clientHeight;
            const scrollTop = preview.scrollTop;
            const percent = scrollTop / preview.scrollHeight;

            if (scrollTop === 0) {
                cm.scrollTo(0, 0);
            } else if (scrollTop + height >= cmScrollEle.scrollHeight) {
                cm.scrollTo(0, cmScrollEle.scrollHeight);
            } else {
                cm.scrollTo(0, cmScrollEle.scrollHeight * percent);
            }
        };

        const cmBindScroll = function() {
            cmScrollEle.addEventListener(utils.mouseOrTouch('scroll', 'touchmove'), _cmirrorScrollHandler);
        };

        const cmUnbindScroll = function() {
            cmScrollEle.removeEventListener(utils.mouseOrTouch('scroll', 'touchmove'), _cmirrorScrollHandler);
        };

        const previewBindScroll = function() {
            preview.addEventListener(utils.mouseOrTouch('scroll', 'touchmove'), _previewScrollHander);
        };

        const previewUnbindScroll = function() {
            preview.removeEventListener(utils.mouseOrTouch('scroll', 'touchmove'), _previewScrollHander);
        };

        cmEle.addEventListener('mouseover', cmBindScroll);
        cmEle.addEventListener('touchstart', cmBindScroll);
        cmEle.addEventListener('mouseout', cmUnbindScroll);
        cmEle.addEventListener('touchend', cmUnbindScroll);

        if (settings.syncScrolling === 'single') {
            return this;
        }

        preview.addEventListener('mouseover', previewBindScroll);
        preview.addEventListener('touchstart', previewBindScroll);
        preview.addEventListener('mouseout', previewUnbindScroll);
        preview.addEventListener('touchend', previewUnbindScroll);
    }

    private setFullScreen(full) {
        // 用户可以指定是否全屏，未指定时则进行toggle操作
        this.dFullscreen = full !== undefined ? !!full : !this.dFullscreen;

        if (this.dFullscreen && !this.resizeHandler) {
            this.resizeHandler = utils.throttle(this._handleViewResize, 300);
            window.addEventListener('resize', this.resizeHandler);
        }

        if (!this.dFullscreen && this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = null;
        }
    }

    private watching() {
        // 如果是阅读模式或全屏预览模式
        if (this.mode === 'reader' || this.dPreview) {
            return;
        }

        this.dWatching = !this.dWatching;
        if (this.dWatching && !this.dPreviewHtml) {
            return this.convert(this.dValue);
        }

        // 预览或实时预览开启时，不清空预览所需的html
        if (this.dWatching || this.dPreview) {
            return;
        }

        this.dPreviewHtml = '';
    }

    private preview() {
        if (this.mode === 'reader') {
            return;
        }

        this.dPreview = !this.dPreview;
        this.dPreview && this.setFullScreen(true);
        if (this.dPreview && !this.dPreviewHtml) {
            return this.convert(this.dValue);
        }

        if (this.dWatching || this.dPreview) {
            return;
        }

        this.dPreviewHtml = '';
    }

    // help
    private help() {
        ModalService.$modal.show(
            Help,
            {},
            {
                height: 'auto',
                minWidth: 320,
                width: Math.max(this.$el.clientWidth * 0.6, 320),
                scrollable: true,
                root: this,
            },
            {
                'before-close': event => {
                    // console.log('this will be called before the modal closes');
                },
            }
        );
    }

    private addImage(callback) {
        ModalService.$modal.show(
            AddImage,
            {
                addExistImage: callback,
            },
            {
                height: 'auto',
                scrollable: true,
                clickToClose: false,
                root: this,
            },
            {
                'before-close': event => {},
            }
        );
    }

    private hidenImage() {
        ModalService.$modal.hide(AddImage);
    }

    @Watch('value')
    private valueWatcher(newValue: any) {
        // 调用组件时直接通过v-mode传值
        // codemirror change事件时emit input事件
        if (newValue !== this.dValue) {
            this.dValue = newValue;
            if (this.mode === 'reader') {
                this.ready && this.convert(newValue);
            } else {
                this.cm && this.cm.setValue(newValue);
            }
        }
    }
}
